import React, { useState } from "react";
import { useAuth } from "../hooks/useAuth";
import { Navigate } from "react-router-dom";
import { Link } from "react-router-dom";
import { useDialog } from '../components/Modal/DialogContext';
import { useNavigate } from "react-router-dom";



const RequestPasswordReset: React.FC = () => {
    const { user, requestPasswordReset } = useAuth();
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState<string | null>(null);
    const [loading, setLoading] = useState(false);
    const [showEmailError, setShowEmailError] = useState(false);
    const dialog = useDialog();
    const navigate = useNavigate();
    if (user) return <Navigate to="/" />; // ✅ Weiterleiten wenn eingeloggt

    const validateEmail = (value: string) => {
        return /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(value);
    };

    const handlePasswordReset = async (e: React.FormEvent) => {
        e.preventDefault();
        if (!validateEmail(email)) {
            setShowEmailError(true);
            return;
        } else {
            setShowEmailError(false);
        }

        setLoading(true);
        setError(null);

        try {
            await requestPasswordReset(email);
            dialog({
                type: 'alert',
                title: 'E-Mail versendet',
                message: 'Falls diese E-Mail-Adresse bei uns registriert ist, haben wir Ihnen eine Nachricht zum Zurücksetzen Ihres Passworts gesendet. Sie werden nun zum Login weitergeleitet.',
                confirmButton: 'OK',
                onConfirm: () => navigate("/login"),

            });
           
        } catch (err: any) {
            setError(err.message);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="tw-h-full tw-overflow-auto tw-px-5 sm:tw-px-0">
            <div className="sm:tw-max-w-[90%] tw-w-full tw-mx-auto tw-h-full">
                <div className="tw-flex tw-flex-col tw-h-full">
                    <Link to="/" className="undefined active-class">
                    <nav className="tw-flex tw-justify-center tw-sticky tw-top-0 tw-py-3 tw-bg-white tw-z-10">
                        <div><a href=""><img src="/kvita-logo.png" width="200" alt="logo" /></a></div>
                    </nav></Link>
                    <main className="tw-flex-1 tw-grid md:tw-items-center">
                        <div className="tw-max-w-[400px] tw-w-full tw-flex tw-items-center tw-py-6 tw-mx-auto tw-relative">
                            <div>

                                <div className="tw-text-center tw-mb-8">
                                    <h3>Passwort zurücksetzen</h3>
                                    <p className="tw-text-gray-500">
                                        Geben Sie unten Ihre E-Mail-Adresse ein. Wir senden Ihnen einen Link zum Zurücksetzen Ihres Passworts.
                                    </p>
                                </div>
                                <form onSubmit={handlePasswordReset}>
                                    <div className="tw-mb-6">
                                        <div className="auth-input-field">
                                            <label className="tw-text-gray-black tw-inline-block tw-mb-2 tw-text-xs">Email</label>
                                            <div className="tw-relative">
                                                <input
                                                    required
                                                    placeholder="name@beispiel.de"
                                                    type="text"

                                                    className="tw-border tw-p-2 tw-font-normal tw-text-sm tw-border-solid tw-border-black tw-text-gray-black tw-rounded-lg tw-w-full tw-block tw-outline-none tw-border-gray-100 focus:tw-border-primary-500 hover:tw-border-[#C2C2C2]"
                                                    onChange={(e) => setEmail(e.target.value)}

                                                />
                                            </div>
                                            {showEmailError && (
                                                <p className="input__container__div__error !tw-text-xs">
                                                    Ungültiges E-Mail-Format. Bitte geben Sie Ihre E-Mail-Adresse in diesem Format ein: name@beispiel.de
                                                </p>
                                            )}
                                        </div>
                                    </div>
                                    <div className="tw-absolute tw-bottom-0 tw-left-0 tw-w-full md:tw-static">
                                        <button id=""
                                            type="submit"
                                            className="_button_19rto_40 _primary_19rto_127 _filled_19rto_80 _block_19rto_52 tw-text-base tw-font-medium"
                                            disabled={loading || !email}>
                                            <div className="_btnFlex_19rto_32">Reset-Link senden</div>
                                        </button>
                                    </div>
                                </form>
                                {error && <p className="tw-text-red-500 tw-text-sm tw-mt-2">{error}</p>}
                            </div>
                        </div>
                    </main>

                </div>
                <footer className="tw-flex tw-pb-6 tw-flex-col tw-items-center">

                    <div className="tw-mt-6 tw-flex tw-items-center tw-gap-2 tw-text-gray-500 tw-mx-auto tw-text-xs">
                        <p className="tw-my-0">Sie brauchen Hilfe?</p><a className="hover:tw-text-primary-500 hover:tw-underline"
                            href="" target="_blank" rel="noreferrer"><span
                                className="tw-underline">Support kontaktieren</span><svg width="16" height="16" viewBox="0 0 16 16"
                                    fill="none" xmlns="http://www.w3.org/2000/svg" className="tw-ml-[6px] tw-text-inherit">
                                <path
                                    d="M8.6624 7.83219C8.53573 7.83219 8.40906 7.78552 8.30906 7.68552C8.11573 7.49219 8.11573 7.17219 8.30906 6.97885L13.7757 1.51219C13.9691 1.31885 14.2891 1.31885 14.4824 1.51219C14.6757 1.70552 14.6757 2.02552 14.4824 2.21885L9.01573 7.68552C8.91573 7.78552 8.78906 7.83219 8.6624 7.83219Z"
                                    fill="currentColor"></path>
                                <path
                                    d="M14.6688 5.03594C14.3954 5.03594 14.1687 4.80927 14.1687 4.53594V1.83594H11.4688C11.1954 1.83594 10.9688 1.60927 10.9688 1.33594C10.9688 1.0626 11.1954 0.835938 11.4688 0.835938H14.6688C14.9421 0.835938 15.1687 1.0626 15.1687 1.33594V4.53594C15.1687 4.80927 14.9421 5.03594 14.6688 5.03594Z"
                                    fill="currentColor"></path>
                                <path
                                    d="M10.0026 15.1693H6.0026C2.3826 15.1693 0.835938 13.6226 0.835938 10.0026V6.0026C0.835938 2.3826 2.3826 0.835938 6.0026 0.835938H7.33594C7.60927 0.835938 7.83594 1.0626 7.83594 1.33594C7.83594 1.60927 7.60927 1.83594 7.33594 1.83594H6.0026C2.92927 1.83594 1.83594 2.92927 1.83594 6.0026V10.0026C1.83594 13.0759 2.92927 14.1693 6.0026 14.1693H10.0026C13.0759 14.1693 14.1693 13.0759 14.1693 10.0026V8.66927C14.1693 8.39594 14.3959 8.16927 14.6693 8.16927C14.9426 8.16927 15.1693 8.39594 15.1693 8.66927V10.0026C15.1693 13.6226 13.6226 15.1693 10.0026 15.1693Z"
                                    fill="currentColor"></path>
                            </svg></a>
                    </div>
                </footer>
            </div>
        </div >



    );
};

export default RequestPasswordReset;